/**
 * Formats a given number as a currency string based on the specified currency and the user's locale.
 *
 * @param value - The numeric value to be formatted.
 * @param currency - The currency code to format the value in. Can be either 'EUR' or 'USD'.
 * @returns A string representing the formatted currency value.
 */
export function formatAmount(value: number, currency: 'EUR' | 'USD') {
  const locale: string = currency === 'USD' ? 'en-GB' : 'it-IT';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
}
